<div class="wrapper">
  <app-header></app-header>
  <div class="main">
      <div class="container-fluid container-fluid-5">
          <div class="row row5">
              <div class="sidebar col-md-2 hide-small">
                  <app-sidebar></app-sidebar>
              </div>
              <div class="col-12 hide-large featured-box">
              </div>
              <div class="col-md-10 report-main-content m-t-5">
                <div class="card">
                  <div class="card-header"><h4 class="mb-0">Transaction History</h4></div>
                  <div class="card-body container-fluid container-fluid-5">
                    <div class="date_picker row">
                        <div class="datepicker_input fromDate_input">
                          <div class="kyc-dropdown">
                            <div class="select-wrapper">
                              <input type="text" placeholder="From Date" class="form-control" [popover]="popTemplate"
                                placement="bottom" [outsideClick]="true" #startpopoverRef="bs-popover"
                                value="{{startdateTime | date:'yyyy-MM-dd'}}" (click)="showDate()">
                            </div>
                          </div>
                        </div>
                        <div class="datepicker_input toDate_input">
                          <div class="kyc-dropdown">
                            <div class="select-wrapper">
                              <input type="text" placeholder="To Date" class="form-control" [popover]="popTemplate1"
                                placement="bottom" [outsideClick]="true" #endpopoverRef="bs-popover"
                                value="{{enddateTime | date:'yyyy-MM-dd'}}" (click)="showDate()">
                            </div>
                          </div>
                        </div>
                        <div class="datepicker_input">
                          <div class="open_bet_row">
                            <select class="form-select" aria-label="Default select example" [(ngModel)]="searchType">
                              <option selected>Select transaction type</option>
                             
                              <option value="2">Withdrawl</option>
                              <option value="1">Deposit</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-1 col-md-1 col-12 btn-col">
                            <button class="btn btn-primary btn-block mobile-width" (click)="rerender()">Submit</button>
                          </div>
                       
                      </div>
        
                      <div class="data_table mt-4">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                        </table>
                      </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</div>

<app-footer-main></app-footer-main>

<!-- Date Time Picker -->
<ng-template #popTemplate>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="date" [minDate]="minDate" [maxDate]="todayDateTime"
      [showWeeks]="false" (ngModelChange)="updateDate()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker style="color:black" [showSeconds]="seconds" [hidden]="!isDateVisible" [(ngModel)]="time"
      (ngModelChange)="updateTime()" [showMeridian]="isMeridian">
    </timepicker>
  </ng-template>
  <ng-template #popTemplate1>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDate" [minDate]="date" [maxDate]="todayDateTime"
      [showWeeks]="false" (ngModelChange)="updateEndDate()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTime" (ngModelChange)="updateEndTime()" show-seconds="true"
      [showMeridian]="isMeridian" [showSeconds]="seconds">
    </timepicker>
  </ng-template>
